module.exports = __webpack_public_path__ + "static/media/parking.497e39a8.svg";